import React, { useCallback, useEffect } from 'react'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getIsPoliciesLoading, getPoliciesActiveIVBVehicles, getProductIcons } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import { getLicensePlate, isPolicyPullable } from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoadingIndicator from '~/components/LoadingIndicator'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { useNavigate } from 'react-router-dom'
import { getTowedVehicleBranches } from '@verzekeringapp-mono/shared/src/state/selectors/ivb'

const GreenCardsScreen: React.FC = () => {
  const { getPolicies } = usePolicies()

  const towedVehicleBranches = useAppSelector(getTowedVehicleBranches)
  const policies = useAppSelector(getPoliciesActiveIVBVehicles)
  const isLoading = useAppSelector(getIsPoliciesLoading)
  const navigate = useNavigate()
  const productIcons = useAppSelector(getProductIcons)

  useEffect(() => {
    getPolicies()
  }, [])

  const onPolicyPressed = useCallback((policy: IPolicy) => {
    if (policy.greenCard) {
      window.open(policy.greenCard, '_blank', 'noopener,noreferrer')

      return
    }

    if (isPolicyPullable(policy, towedVehicleBranches)) {
      navigate(`/verzekeringsbewijzen/genereren/${policy.policyNumber}`)
    }
  }, [navigate, towedVehicleBranches])

  return (
    <ScreenWrapper>
      <div>
        {isLoading && (
          <div className='flex justify-center items-center mb-4'>
            <LoadingIndicator />
          </div>
        )}

        {policies.map((policy) => (
          <div
            key={policy.id}
            className='mb-4 flex cursor-pointer items-center justify-between rounded bg-surface-card p-4'
            onClick={() => onPolicyPressed(policy)}
          >
            <div className='flex items-center'>
              <div className='mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-[25px] bg-surface-brand-subtle'>
                <FontAwesomeIcon
                  icon={productIcons[policy.productId]}
                  size='lg'
                  className='text-icon-brand'
                />
              </div>

              <div>
                <p>{policy.productName}</p>

                <p className='light text-sm'>
                  Kenteken: {getLicensePlate(policy.details) ?? ''}
                </p>

                <p className='light text-sm'>
                  Polisnummer: {policy.policyNumber}
                </p>
              </div>
            </div>

            <FontAwesomeIcon
              icon={['fal', 'chevron-right']}
              className='text-icon-secondary'
            />
          </div>
        ))}
      </div>
    </ScreenWrapper>
  )
}

export default GreenCardsScreen
